<div class="header-wraper" style="width: 100%; display: flex; height: 55px">
  <nav
    style="width: 90%; float: left; margin: 10px 0px"
    class="navbar navbar-expand-lg headerContainer mb-3"
  >
    <a class="navbar-brand d-flex">
      <img
        src="../../../assets/images/5_image.jpg"
        style="width: 50px; padding: 0px 5px"
      />

      <div class="logoTxt">
        <strong>AI Analytics</strong>
        <span>Process Automation </span>
      </div>
    </a>
  </nav>
  <span
    style="
      width: 10%;
      justify-content: end;
      padding: 15px;
      display: inline-flex;
      height: 55px;
      align-items: center;
    "
  >
    <div class="dropdown">
      <button
        class="btn dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {{ loginedUserDetails?.username }}
      </button>
      <ul class="dropdown-menu">
        <li (click)="clearStorage()">
          <a class="dropdown-item"
            ><i
              class="fa fa-sign-out nav-icons-dropdown"
              aria-hidden="true"
            ></i>
            &nbsp;&nbsp;Logout</a
          >
        </li>
      </ul>
    </div>
  </span>
  <!-- <span style="width:10%; justify-content: end; padding:15px; display: inline-flex; height: 55px;align-items: center;">
  <a class="userDropdownMenu nav-link scale-class pull-right" (click)="clearStorage()"
                                tooltip="Logout" [options]="myOptions"> <i class="fa fa-sign-out nav-icons-dropdown"
                                    aria-hidden="true"></i><span style="color: #fff;" class="userDropdownMenuText">
                                    Logout</span></a>
                                    </span> -->
</div>
<div class="access-loader" *ngIf="bodySpinner"></div>
<div class="page-title">
  <span class="d-flex justify-content-center w-97"
    ><h4>AI Analytics, Summarization, and Process Automation</h4></span
  >
  <span
    class="icon user-management-icon"
    *ngIf="loginedInRole == 'Admin'"
    (click)="OpenModel('user-privilege')"
  >
    <i class="user-privilege"></i>
    <span class="tooltip-text">User Management</span>
  </span>
</div>
<div class="apps-wrapper" *ngIf="!bodySpinner">
  <span *ngIf="spinner">
    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i
  ></span>
  <div class="d-flex align-items-center justify-content-center list-apps">
    <div class="list">
      <div
        class="card"
        *ngIf="isAllowed('SmartAIAgent')"
        (click)="selectedApps('SmartAIAgent')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="voice-agent"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">Voice Agent</p>
        </div>
      </div>
      <div
        class="card"
        *ngIf="isAllowed('Campaign')"
        (click)="selectedApps('Campaign')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="campaign"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">Campaign</p>
        </div>
      </div>
      <div
        class="card"
        *ngIf="isAllowed('Call')"
        (click)="selectedApps('audio')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="bi bi-headset"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">Call Analytics</p>
        </div>
      </div>
      <div
        class="card"
        *ngIf="isAllowed('VoiceMail')"
        (click)="selectedApps('voiceMail')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="bi bi-voicemail"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">Voice Mail</p>
        </div>
      </div>
      <div class="card" *ngIf="isAllowed('IVR')" (click)="selectedApps('ivr')">
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="bi bi-soundwave"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">IVR</p>
        </div>
      </div>
      <div
        class="card"
        *ngIf="isAllowed('Email')"
        (click)="selectedApps('email')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="bi bi-envelope-open"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">Email</p>
        </div>
      </div>
       <div
        class="card"
        *ngIf="isAllowed('EmailAudit')"
        (click)="selectedApps('emailAudit')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="bi bi-envelope-open"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">Email Analytics</p>
        </div>
      </div>
      <div
        class="card"
        *ngIf="isAllowed('Survey')"
        (click)="selectedApps('survey')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="bi bi-graph-up-arrow"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">Survey / NPS</p>
        </div>
      </div>
    </div>
    <div class="list">
      <div
        class="card"
        *ngIf="isAllowed('Text')"
        (click)="selectedApps('text')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="bi bi-file-text"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">Text</p>
        </div>
      </div>

      <div
        class="card"
        *ngIf="isAllowed('Document')"
        (click)="selectedApps('document')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="bi bi-file-earmark"></i>
            </span>
          </div>

          <p class="card-text">Document</p>
        </div>
      </div>
      <div
        class="card"
        *ngIf="isAllowed('CLM')"
        (click)="selectedApps('contract')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="contract-hand"></i>
            </span>
          </div>

          <p class="card-text">Contract</p>
        </div>
      </div>

      <div
        class="card"
        *ngIf="isAllowed('RFP')"
        (click)="selectedApps('rfpcontract')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="contract"></i>
            </span>
          </div>

          <p class="card-text">RFP</p>
        </div>
      </div>
      <div
        class="card"
        *ngIf="isAllowed('InfoSec')"
        (click)="selectedApps('infosecurity')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="bi bi-shield-lock"></i>
            </span>
          </div>

          <p class="card-text">Information Security</p>
        </div>
      </div>

      <div
        class="card"
        *ngIf="isAllowed('SocialMedia')"
        (click)="selectedApps('social-media')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="social-media"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">Social Media</p>
        </div>
      </div>

      <!-- <div class="holographic-container">
    <div class="holographic-card">
      <h2>HOLOGRAM</h2>
    </div>
  </div> -->
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-center list-apps">
    <div class="list"></div>
  </div>
  <div style="width: 100%; background: #c3c3c3; height: 1px"></div>
  <div class="d-flex align-items-center justify-content-center list-apps">
    <div class="list">
      <div
        class="card"
        *ngIf="isAllowed('AIAssistance')"
        (click)="selectedApps('ai-assist')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="fa fa-robot"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">AI Assistance</p>
        </div>
      </div>
      <div
        class="card"
        *ngIf="isAllowed('Reports')"
        (click)="selectedApps('reports')"
      >
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <span class="call-app-icon">
              <i class="custom-report"></i>
            </span>
          </div>
          <!-- <p class="card-subtitle">Call Analytics</p> -->
          <p class="card-text">BI Dashboards and Reports</p>
        </div>
      </div>
    </div>
  </div>
</div>
<app-dialog-modal
  [isVisible]="isModalVisible"
  [popLoader]="popLoader"
  [size]="metricFullscreen ? 'full-screen' : 'large'"
>
  <div modal-header class="modal-header ai-logo">
    <h4 class="modal-title">User Apps Privilege</h4>
    <span>
      <i
        class="fa metricFullscreen"
        [ngClass]="{
          'fa-down-left-and-up-right-to-center': metricFullscreen,
          'fa-up-right-and-down-left-from-center': !metricFullscreen,
        }"
        (click)="metricFullscreen = !metricFullscreen"
      ></i
      >&nbsp;&nbsp;
      <i
        class="fa-solid fa-xmark exitIcon"
        #closebutton
        data-bs-dismiss="modal"
        aria-label="Close"
        (click)="closeModal()"
      ></i>
    </span>
  </div>
  <div modal-body class="modal-body">
    <div class="left-panel">
      <div
        class="position-relative px-1 py-1 d-flex flex-row align-items-center"
      >
        <span class="search-wrapper">
          <span class="icon"><i class="fa-solid fa-magnifying-glass"></i></span>
          <input
            type="text"
            [(ngModel)]="listSearch"
            autocomplete="off"
            placeholder="Search user"
            class="form-control audioTableSearchInput"
            name="searchInput"
            id="searchInput"
          />
          <span class="icon" (click)="listSearch = ''"
            ><i *ngIf="listSearch" class="fa-solid fa-xmark"></i
          ></span>
        </span>
        <button
          class="btn new-btn"
          (click)="newUser()"
          [options]="myOptions"
          tooltip="Add New User"
        >
          +
        </button>
      </div>

      <div class="position-relative">
        <ul
          class="list-items-v"
          appScrollNearEnd
          [threshold]="2"
          (nearEnd)="onNearEndScroll()"
        >
          @for (
            user of userListData | filter: listSearch : "username";
            track user.id
          ) {
            <li
              (click)="selectUser(user)"
              [class.active]="userselectedId == user.id"
            >
              <span>{{ user?.username }}</span>
              <span>{{ user?.email }}</span>
            </li>
          }
        </ul>
      </div>
    </div>
    <div class="right-panel">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4><b>User Detail</b></h4>
        <ng-container *ngIf="userselectedId">
          <ul class="list-group list-group-horizontal IconClass">
            <li class="list-group-item">
              <a
                [attr.disabled]="userDetailInput?.role === 'Admin'"
                [ngClass]="
                  userDetailInput?.role === 'Admin' ? 'disableClass' : ''
                "
                *ngIf="!userDetailInput?.is_active"
                class="listIcon delete"
                tooltip="Deactivate"
                [options]="myOptions"
              >
                <i
                  class="fa fa-ban"
                  aria-hidden="true"
                  (click)="deactivateUserFun(userDetailInput)"
                ></i>
              </a>
              <a
                [attr.disabled]="userDetailInput?.role === 'Admin'"
                [ngClass]="
                  userDetailInput?.role === 'Admin' ? 'disableClass' : ''
                "
                *ngIf="userDetailInput?.is_active"
                class="listIcon"
                tooltip="Activate"
                [options]="myOptions"
              >
                <i
                  class="fa fa-check"
                  aria-hidden="true"
                  (click)="deactivateUserFun(userDetailInput)"
                ></i>
              </a>
            </li>
            <!-- <li class="list-group-item">
                    <a [attr.disabled]="userDetailInput?.role === 'Admin'"
                        [ngClass]="userDetailInput?.role === 'Admin'? 'disableClass':''"
                        class="listIcon" tooltip="Reset Password" [options]="myOptions">
                        <i class="fa fa-lock" aria-hidden="true" (click)="openPasswordForm()"></i></a>
                </li> -->
            <li class="list-group-item">
              <a
                [attr.disabled]="userDetailInput?.role === 'Admin'"
                [ngClass]="
                  userDetailInput?.role === 'Admin' ? 'disableClass' : ''
                "
                aria-disabled="true"
                class="listIcon delete"
                tooltip="Delete"
                [options]="myOptions"
              >
                <i
                  class="fa fa-trash"
                  aria-hidden="true"
                  (click)="deleteUserFun(userDetailInput)"
                ></i
              ></a>
            </li>
          </ul>
        </ng-container>
      </div>
      <div class="d-flex flex-column">
        <span *ngIf="spinner">
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i
        ></span>

        <form [formGroup]="userForm" autocomplete="off">
          <div class="row">
            <div class="col">
              <!-- <div class="card userDetailsCard" *ngIf=" userSubscription !== 1 && userSubscription "> -->
              <div class="">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label mandatoryLabel"
                        >User Name
                        <i class="fa-solid fa-asterisk mandatoryIcon"></i
                      ></label>
                      <input
                        type="text"
                        TrimText
                        class="form-control"
                        formControlName="username"
                        name="username"
                        placeholder="Enter user name"
                      />
                      <span
                        class="text-danger"
                        *ngIf="
                          submitted && userForm.hasError('required', 'username')
                        "
                      >
                        User name is required.
                      </span>
                      <span
                        class="text-danger"
                        *ngIf="
                          submitted && userForm.hasError('pattern', 'username')
                        "
                      >
                        Invalid input: Only special characters (space, &, comma,
                        -) are allowed.
                      </span>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="form-label mandatoryLabel"
                        >User Role
                        <i class="fa-solid fa-asterisk mandatoryIcon"></i
                      ></label>

                      <ng-select
                        placeholder="Select"
                        [multiple]="false"
                        formControlName="role"
                        name="role"
                        class="transcribeClass"
                      >
                        @for (role of roleList; track role.id) {
                          <ng-option
                            *ngIf="role.is_active"
                            value="{{ role.name }}"
                            [disable]="role.name == 'Admin'"
                            >{{ role.name }}</ng-option
                          >
                        }
                      </ng-select>

                      <span
                        class="text-danger"
                        *ngIf="
                          submitted && userForm.hasError('required', 'role')
                        "
                      >
                        User role is required.
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        class="form-label mandatoryLabel"
                        [ngClass]="{
                          'is-invalid': submitted && f['email'].errors,
                        }"
                        >Email <i class="fa-solid fa-asterisk mandatoryIcon"></i
                      ></label>
                      <input
                        type="email"
                        class="form-control"
                        formControlName="email"
                        name="email"
                        id="email"
                        placeholder="example@gmail.com"
                      />
                      <div
                        *ngIf="submitted && f['email'].errors"
                        class="invalid-feedback"
                      >
                        <div
                          class="text-danger"
                          *ngIf="f['email'].errors['required']"
                        >
                          Email is required
                        </div>
                        <div
                          class="text-danger"
                          *ngIf="f['email'].errors['pattern']"
                        >
                          Email is not Valid
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        class="form-label mandatoryLabel"
                        [ngClass]="{
                          'is-invalid': submitted && f['phone_number'].errors,
                        }"
                        >Phone Number
                        <i class="fa-solid fa-asterisk mandatoryIcon"></i
                      ></label>
                      <!-- <input type="tel" class="form-control" formControlName="phone_number"
                                                name="phone_number" id="phonenumber" placeholder="Enter phone number" ng2TelInput
                                                [ng2TelInputOptions]="{initialCountry: 'in'}" (hasError)="hasError($event)"
                                                (ng2TelOutput)="getNumber($event)" (intlTelInputObject)="telInputObject($event)"
                                                (countryChange)="onCountryChange($event)"> -->

                      <!-- <input #intlInput TrimText formControlName="phone_number" id="phonenumber" name="phonenumber"
                                            class="form-control" type="text"
                                            placeholder="Enter phone number" (input)="onInputPhoneChange($event)">
                                            <div *ngIf="submitted && f['phone_number'].errors" class="invalid-feedback">
                                                <div class="text-danger" *ngIf="f['phone_number'].errors['required']">
                                                    Phone number is required</div>
                                                <div class="text-danger" *ngIf="f['phone_number'].errors['pattern'] || f['phone_number'].errors['minlength']">Phone number
                                                    is not valid</div>
                                            </div>   -->
                      <app-phone-number-input
                        #phoneComp
                        formControlName="phone_number"
                        [isInvalid]="
                          (submitted || f['phone_number'].touched) &&
                          !!f['phone_number'].errors
                        "
                        [parentErrors]="f['phone_number'].errors"
                        defaultCountry="US"
                        >></app-phone-number-input
                      >
                      <!-- <app-phone-input formControlName="phone_number"></app-phone-input> 
                                              <div class="text-danger" *ngIf="userForm.hasError('pattern','phone_number')">Phone number
                                                    is not valid</div>-->
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label
                        class="form-label mandatoryLabel"
                        [ngClass]="{
                          'is-invalid': submitted && f['apps'].errors,
                        }"
                        >Allowed Apps
                        <i class="fa-solid fa-asterisk mandatoryIcon"></i>
                      </label>

                      <ng-select
                        placeholder="Select"
                        [multiple]="true"
                        formControlName="apps"
                        name="apps"
                        class="transcribeClass"
                      >
                        @for (app of allApps; track app.id) {
                          <ng-option [value]="app.id">{{ app.name }}</ng-option>
                        }
                      </ng-select>

                      <div
                        *ngIf="submitted && f['apps'].errors"
                        class="invalid-feedback"
                      >
                        <div
                          class="text-danger"
                          *ngIf="f['apps'].errors['required']"
                        >
                          Apps is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="d-flex text-end mt-3">
                    <button
                      class="btn btn-light cancelBtn"
                      type="button"
                      (click)="pressCancel()"
                    >
                      Cancel
                    </button>
                    <button
                      class="btn btn-primary updateBtn"
                      *ngIf="userselectedId == null"
                      type="submit"
                      (click)="onSubmit()"
                    >
                      Save
                    </button>
                    <button
                      class="btn btn-primary updateBtn"
                      *ngIf="userselectedId != null"
                      type="submit"
                      (click)="onSubmit()"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- <div modal-footer class="modal-footer">
     
  </div> -->
</app-dialog-modal>
